import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=aac214e0"
import script from "./PersonalData.vue?vue&type=script&lang=js"
export * from "./PersonalData.vue?vue&type=script&lang=js"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=aac214e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports